import React from 'react';

import * as styles from './VideoPlayIndicator.styles';

export interface VideoPlayIndicatorProps {
  /** `sm` for the modal thumbnail rail, `lg` for a full media poster. */
  size?: 'lg' | 'sm';
}

/**
 * Marks a video poster as a video. Decorative and non-interactive: it always sits inside a
 * labelled control (a carousel slide, a grid tile, a thumbnail button), so it must not add a
 * second focus target or announce itself. It centres itself over the nearest positioned
 * ancestor, which every poster surface already provides.
 *
 * A path rather than the "▶" character: at 48px a text glyph is liable to be substituted by
 * the platform's colour emoji, which would neither match the design nor be stable in Percy.
 */
export const VideoPlayIndicator = ({ size = 'sm' }: VideoPlayIndicatorProps) => (
  <span aria-hidden="true" css={styles.root} data-size={size} data-testid="video-play-indicator">
    <svg fill="currentColor" focusable="false" viewBox="0 0 16 16">
      {/* Leading edge inset further than the tip so the triangle reads as optically centred. */}
      <path d="M4.5 2.5 L13 8 L4.5 13.5 Z" />
    </svg>
  </span>
);
